module.exports = __webpack_public_path__ + "assets/img/ma-logo-17a214b1.png";